import React from 'react';
import errorImg from '../../assets/img/404.svg';
import './style.css'

const errorPage = () => {
    return (
        <div style={styles}></div>
    );
}

const styles = {
    background: `url(${errorImg}) no-repeat center`,
    backgroundSize: 'cover',
    minHeight: '80vh'
}
export default errorPage;